import { compose } from 'redux'
import { connect } from 'react-redux'
import { updateWPLocalDataFrontByKey } from '../../actions'
import hasActiveSelection from '../../hoc/hasActiveSelection'
import hasMovies from '../../hoc/hasMovies'
import toJS from '../../hoc/toJS'
import DisplayProgramOverviewMenu from '../../components/PageWebsiteSubpages/DisplayProgramOverviewMenu';
import getData from '../../functions/getData'
import { CLI_CURRENT_CINEMA_ID, PROGRAM_ATTRIBUTES, PROGRAM_CINEMAS } from '../../constants/state'

const mapDispatchToProps = dispatch => ({
    onUpdateProgramOverviewSubmenus: (input) => {
        dispatch(updateWPLocalDataFrontByKey('program_overview_submenus', input))
    }
})

const mapStateToProps = state => ({
    programOverviewSubmenus: state.getIn(['wpLocalData', 'data', 'data', 'front', 'program_overview_submenus']) ? state.getIn(['wpLocalData', 'data', 'data', 'front', 'program_overview_submenus']) : state.getIn(['wpServerData', 'data', 'data', 'front', 'program_overview_submenus']),
    attributes: getData(state, PROGRAM_ATTRIBUTES),
    cinemas: getData(state, PROGRAM_CINEMAS),
    currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID)
})

const FormProgramOverviewSubmenusContainer = ({transId, currentCinemaId, attributes, type, activeSelection, programOverviewSubmenus, onUpdateProgramOverviewSubmenus, collapseActiveSelection, cinemas}) => {
    return <DisplayProgramOverviewMenu
        transId={transId}
        type={type}
        activeSelection={activeSelection}
        collapseActiveSelection={collapseActiveSelection}
        attributes={attributes}
        cinema={cinemas[currentCinemaId]}
        programOverviewSubmenus={programOverviewSubmenus}
        onUpdateProgramOverviewSubmenus={onUpdateProgramOverviewSubmenus}
    />
}

export default compose(
    hasActiveSelection(),
    hasMovies(),
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(FormProgramOverviewSubmenusContainer)